import { render, staticRenderFns } from "./BindsCardActions.vue?vue&type=template&id=043c2bdd&"
import script from "./BindsCardActions.vue?vue&type=script&lang=js&"
export * from "./BindsCardActions.vue?vue&type=script&lang=js&"
import style0 from "./BindsCardActions.vue?vue&type=style&index=0&id=043c2bdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports